document.addEventListener('DOMContentLoaded', () => {
  const INSTALLATION_VARIANT_ID = 52190846910806;

  const checkbox = document.getElementById('installation-checkbox');
  const addToCartBtn = document.querySelector('[type="submit"][name="add"]');

  if (!checkbox || !addToCartBtn) return;

  addToCartBtn.addEventListener('click', async () => {
    if (!checkbox.checked) return;

    const cart = await fetch('/cart.js').then(r => r.json());

    const alreadyAdded = cart.items.some(
      item => item.variant_id === INSTALLATION_VARIANT_ID
    );

    if (!alreadyAdded) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: INSTALLATION_VARIANT_ID,
          quantity: 1
        })
      });
    }
  });
});
